<p-select
  [options]="tierList"
  [filter]="true"
  filterBy="label, value"
  [(ngModel)]="selectedTier"
  (onChange)="selectTier($event.value)"
  [placeholder]="!selectedTier ? 'Manual' : selectedTier.getName()"
  class="margin-dropdown"
  data-cy="quote-margin"
>
</p-select>

@for (containerName of equipment; track containerName) {
  <span class="margin-wrapper">
    <span class="margin-label">
      {{ containerName | formatContainerLabel }}
    </span>
    <input
      pInputText
      [ngModel]="values[containerName]"
      type="number"
      step="0.1"
      (keyup)="updateValue($event, containerName)"
      class="form-control margin-input"
      data-cy="quote-margin-input"
    />
  </span>
}

<button
  pButton
  severity="success"
  [disabled]="saving"
  (click)="applyCustomMargin()"
  data-cy="quote-margin-apply"
>
  @if (saving) {
    <i class="pi pi-spinner pi-spin" aria-hidden="true"></i>
  }
  Apply
</button>
